import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';

class Intro extends Component {

    gtag_report_conversion = (event, url = null) => {
        if (typeof window.gtag !== "function") {
            console.error("Google Ads is not loaded properly.");
            return;
        }

        window.gtag('event', 'conversion', {
            'send_to': 'AW-16832649503/oq0QCPbF0ZYaEJ-yt9o-'
        });

        console.log("Conversion event sent:", event.target);

        if (url) {
            setTimeout(() => {
                window.location.href = url;
            }, 500);
        }
    };


    render() {
        return (
            <section className="pt-100 center-about bg-grey">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading text-center">
                                <span>Step into the Future of Control</span>
                                <h2>Master Adaptive Systems with Neural Networks</h2>
                                {/*<HashLink to="https://www.amazon.es/dp/840976203X">Got Questions About Neural Networks?​ <strong className="text-color" onClick={(event) => this.gtag_report_conversion(event)}> Get Your Free Guidebook to Learn More!</strong> </HashLink>*/}
                                <p>
                                  Got Questions About Neural Networks?{" "}
                                  <a
                                    href="/preview_merged.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(event) => {
                                      // URL dinámica para desarrollo y producción
                                      const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
                                        ? 'https://controlbook.onrender.com'
                                        : 'http://localhost:3000';
                                
                                      // Trackear el click
                                      fetch(`${backendUrl}/clicks`, {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                          sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                                          elementId: "download-free-guidebook",
                                          pageUrl: window.location.href,
                                          elementType: "link", 
                                          userId: "user-react",
                                          coordinates: { x: event.clientX, y: event.clientY },
                                          metadata: {
                                            document: "preview_merged.pdf",
                                            type: "guidebook",
                                            audience: "learners",
                                            purpose: "education",
                                            content: "neural-networks-intro"
                                          }
                                        }),
                                      }).catch(err => console.error('Error tracking click:', err));
                                
                                      // Google Analytics (mantener tu código existente)
                                      if (typeof window.gtag_report_conversion === "function") {
                                        window.gtag_report_conversion(event);
                                      }
                                    }}
                                    style={{ 
                                      fontWeight: "bold", 
                                      color: "#1a73e8", 
                                      textDecoration: "underline" 
                                    }}
                                  >
                                    Get Your Free Guidebook to Learn More!
                                  </a>
                                </p>                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Intro;
